import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker } from "./serviceWorkerRegistration";

// Interceptor global para manejar errores de token
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const detail = error.response?.data?.detail || '';
      if (detail.includes('expired') || detail.includes('Token')) {
        // Token expirado - limpiar sesión y recargar
        localStorage.removeItem('token');
        sessionStorage.removeItem('adminPinVerified');
        delete axios.defaults.headers.common['Authorization'];
        // Mostrar mensaje y recargar
        alert('Tu sesión ha expirado. Por favor, inicia sesión de nuevo.');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Registrar PWA Service Worker
registerServiceWorker();
